import {
    type FC
} from "react";
import {
    View
} from "react-native";
import type IMessageFooterProps from "./type";
import stylesheet, {
    useStyles
} from "./stylesheet";
import {
    NCoreUIKitTheme
} from "../../../../core/hooks";
import type {
    MessagePartContentProps
} from "../../type";
import {
    withMessageContext
} from "../../context";
import MessageStatus from "../status";
import MessageTime from "../time";

const MessageFooterContent: FC<MessagePartContentProps<IMessageFooterProps>> = ({
    customLocalize,
    customTheme,
    children,
    context,
    style,
    ...props
}) => {
    const currentTheme = customTheme ?? context.customTheme;

    const {
        controlPaddings,
        controlHeights,
        typography,
        iconSizes,
        spaces
    } = NCoreUIKitTheme.useContext(currentTheme);

    const isHasActions = context.isPlain && Boolean(context.actions);

    const {
        container: containerDynamicStyle,
        actions: actionsDynamicStyle
    } = useStyles({
        isPlain: context.isPlain,
        align: context.align,
        controlPaddings,
        controlHeights,
        isHasActions,
        typography,
        iconSizes,
        spaces
    });

    const isLastOfGroup = context.groupPosition === "last" || context.groupPosition === "single";

    const isEndMeta = context.align === "end" && !context.isSystem;

    const isTimeShown = isEndMeta && Boolean(context.timestamp);

    const isStatusShown = isEndMeta && Boolean(context.deliveryStatus);

    if(!isLastOfGroup || (!children && !isHasActions && !isTimeShown && !isStatusShown)) {
        return null;
    }

    const renderDefault = () => {
        return <>
            {
                isHasActions ?
                    <View
                        style={actionsDynamicStyle}
                    >
                        {context.actions}
                    </View>
                :
                    null
            }
            {
                isTimeShown && context.timestamp ?
                    <MessageTime
                        customLocalize={customLocalize ?? context.customLocalize}
                        timestamp={context.timestamp}
                        customTheme={currentTheme}
                    />
                :
                    null
            }
            {
                isStatusShown && context.deliveryStatus ?
                    <MessageStatus
                        customLocalize={customLocalize ?? context.customLocalize}
                        status={context.deliveryStatus}
                        customTheme={currentTheme}
                        onRetry={context.onRetry}
                    />
                :
                    null
            }
        </>;
    };

    return <View
        {...props}
        style={[
            style,
            stylesheet.container,
            containerDynamicStyle
        ]}
    >
        {children ?? renderDefault()}
    </View>;
};

const MessageFooter = withMessageContext<IMessageFooterProps>("Footer", MessageFooterContent);
export default MessageFooter;
